import { render, staticRenderFns } from "./versionType.vue?vue&type=template&id=785d81f2&"
import script from "./versionType.vue?vue&type=script&lang=js&"
export * from "./versionType.vue?vue&type=script&lang=js&"
import style0 from "./versionType.vue?vue&type=style&index=0&id=785d81f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports